module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1450.ffffb6de.svg";